export default __webpack_public_path__ + "static/media/compare-and-save.7e65e06e.svg";